class FocusService{
    /*@ngInject*/
    constructor($window,$timeout){
        this.$window = $window;
        this.$timeout = $timeout;
    }
    focus(id){
        this.$timeout(()=>{
            let element = this.$window.document.getElementById(id);
            if(element) {
                element.focus();
            }
        });
    }

}

export default FocusService;


// WEBPACK FOOTER //
// ./public/app/services/focus.service.js